export const SCOPE = "modules/feedback/";

export const GET_ALL_INSIDERS_FEEDBACK = SCOPE + "GET_ALL_INSIDERS_FEEDBACK";
export const GET_INSIDER_FEEDBACK = SCOPE + "GET_INSIDER_FEEDBACK";
export const GET_CANDIDATE_FEEDBACK = SCOPE + "GET_CANDIDATE_FEEDBACK";
export const SUBMIT_INSIDER_FEEDBACK = SCOPE + "SUBMIT_INSIDER_FEEDBACK";
export const SUBMIT_CANDIDATE_FEEDBACK = SCOPE + "SUBMIT_CANDIDATE_FEEDBACK";
export const GET_CANDIDATE_FEEDBACK_RESULT = "GET_CANDIDATE_FEEDBACK_RESULT";
export const ADD_REVIEW = SCOPE + "ADD_REVIEW";



// WEBPACK FOOTER //
// ./src/modules/feedback/types.js